import { useResizeLayoutEffect } from '@cmd/ui-components';
import { getWebComponentTileSize } from '../webComponentUtils';
const useTileSize = (tileRef, onResize) => {
    useResizeLayoutEffect(() => {
        if (tileRef.current && onResize) {
            const rect = tileRef.current.getBoundingClientRect();
            const tileWidth = rect.width;
            onResize(getWebComponentTileSize(tileWidth));
        }
    });
};
export default useTileSize;
